import { Box, styled } from "@mui/material";

const BLOG_TEXT_CONTENT_PREFIX = "BlogTextContent";

export const blogTextContentClasses = {
  root: `${BLOG_TEXT_CONTENT_PREFIX}-root`,
  text: `${BLOG_TEXT_CONTENT_PREFIX}-text`,
};

export const StyledBlogTextContent = styled(Box)(({ theme }) => ({
  [`&.${blogTextContentClasses.root}`]: {
    marginBottom: "32px",
    [`& .${blogTextContentClasses.text}`]: {
      fontSize: "18px",
      lineHeight: "30px",
      color: "#011E3F",
      opacity: 0.9,
    },
  },
}));

